export default __webpack_public_path__ + "static/japanese-3-92135231044ceef5445bac7ddc392899.png";